import DeviceDetails from "./DeviceDetails.vue";

const deviceDetailsCtrl = new Vue({
    el: '#device-details',
    components: {DeviceDetails},
})
